<template>
  <div style="border-radius: 16px">
    <div class="media-list">
      <el-row type="flex" align="bottom">
        <el-col :span="22">
          <div class="breadcrumb-bar">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>音频资源上传</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="tableList">
      <el-form
        :inline="true"
        :model="formResource"
        label-width="120px"
        class="searchForm"
      >
        <el-form-item label="资源专辑名称">
          <el-input v-model="formResource.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>

      <el-progress
        :percentage="percentage"
        :color="customColor"
        :format="formatProgress"
        class="class_progerss"
        v-if="!isNaN(parseInt(percentage))"
      ></el-progress>

      <div class="operBtn">
        <el-button type="primary" icon="plus" @click="addAlbum"
          >新建专辑</el-button
        >
      </div>
      <el-dialog
        :title="desc == 'addResource' ? '新建专辑' : '编辑专辑'"
        :visible.sync="dialogVisible"
        center
        width="40%"
      >
        <el-form :inline="true" :model="formFuzzy" label-width="80px">
          <el-form-item label="资源名称:">
            <el-input
              v-model="formFuzzy.name"
              placeholder="输入名称"
              style="width: 220px"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer" v-if="desc == 'addResource'">
          <el-button type="primary" @click="addResource">下一步</el-button>
          <div style="margin-top: 10px; text-align: initial; font-size: 14px">
            <el-checkbox v-model="checked"></el-checkbox>
            <span>我已同意并阅读</span
            ><a
              href="javascript:;"
              @click="lookKnowLedge"
              style="color: #2d8cf0"
              >《知识产权承诺》</a
            >
          </div>
        </span>
        <span slot="footer" class="dialog-footer" v-if="desc == 'editResource'">
          <el-button type="primary" @click="editResource(ids)"
            >下一步</el-button
          >
          <div style="margin-top: 10px; text-align: initial; font-size: 14px">
            <el-checkbox v-model="checked"></el-checkbox>
            <span>我已同意并阅读</span
            ><a
              href="javascript:;"
              @click="lookKnowLedge"
              style="color: #2d8cf0"
              >《知识产权承诺》</a
            >
          </div>
        </span>
      </el-dialog>
      <el-dialog
        :visible.sync="cenceldialogVisible"
        center
        width="50%"
        title="《知识产权承诺》"
      >
        <p style="text-indent: 30px; line-height: 32px; font-size: 15px">
          您承诺并保证，您在“FanReading”及“听力熊”移动客户端以各种形式发布的信息，均符合《中华人民共和国著作权法》、《中华人民共和国商标法》、《中华人民共和国反不正当竞争法》、《中华人民共和国侵权责任法》、《中华人民共和国广告法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》及《信息网络传播权保护条例》等有关法律、法规、规章的规定。
        </p>
        <p style="text-indent: 30px; line-height: 32px; font-size: 15px">
          您承诺并保证，在“FanReading”及“听力熊”移动客户端以各种形式发布的信息，均符合社会公序良俗；所上传的文字、图片、音频、多媒体资料或其他内容均拥有相应合法的权利。
        </p>
        <span slot="footer" class="dialog-footer" style="text-align: right">
          <el-button type="primary" @click="cenceldialogVisible = false"
            >知道了</el-button
          >
        </span>
      </el-dialog>
      <el-table
        ref="multipleTable"
        :data="queryData"
        :header-cell-style="rowClass"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        v-loading.body="loading"
        id="Table"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column
          prop="id"
          label="资源专辑ID"
          align="center"
          width="120"
        >
          <!-- <template slot-scope="scope">
            <a
              href="javascript:;"
              @click="viewTeacher(scope.row)"
              style="color: #1d90e6"
              >{{ scope.row.id }}</a
            >
          </template> -->
        </el-table-column>
        <el-table-column
          prop="name"
          label="资源专辑名称"
          align="center"
          min-width="120"
        >
          <!-- <template slot-scope="scope">
            <a
              href="javascript:;"
              @click="viewTeacher(scope.row)"
              style="color: #1d90e6"
              >{{ scope.row.name }}</a
            >
          </template> -->
        </el-table-column>
        <el-table-column
          prop="res_count"
          label="数量"
          align="center"
          width="60"
        ></el-table-column>
        <el-table-column
          prop="updated_at"
          label="更新时间"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.updated_at | formatDate2 }}</span>
          </template></el-table-column
        >
        <el-table-column
          prop="layerType"
          label="专辑类型"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.layerType == 2">多层专辑</span>
            <span v-if="scope.row.layerType == 1">单层专辑</span>
          </template></el-table-column
        >
        <el-table-column
          prop="status"
          label="状态"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 0" type="danger">未上架</el-tag>
            <el-tag v-else-if="scope.row.status == 1" type="gray"
              >已上架</el-tag
            >
            <el-tag v-else-if="scope.row.status == 2" type="success"
              >被下架</el-tag
            >
          </template></el-table-column
        >
        <el-table-column
          label="操作"
          show-overflow-tooltip
          align="center"
          width="100"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-tooltip content="编辑" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="bottomOperBtn">
        <el-button
          type="danger"
          @click="delResource"
          icon="delete2"
          style="margin-top: 20px"
          >删除</el-button
        >
        <el-button
          type="primary"
          @click="upResource"
          icon="arrow-up"
          style="margin-top: 20px"
          >上架</el-button
        >
        <el-button
          type="info"
          @click="downResource"
          icon="arrow-down"
          style="margin-top: 20px"
          >下架</el-button
        >
      </div>
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.page"
          :page-sizes="[20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>




<script>
import { ApiMessage, formatDate } from "@/utils/util";
export default {
  name: "audioResources",
  created() {
    this.initCplists();
  },
  data() {
    return {
      do: "",
      formFuzzy: {
        name: "",
      },
      dialogVisible: false,
      cenceldialogVisible: false,
      formResource: {
        name: "",
      },
      queryData: [],
      loading: true,
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      ownCpList: [],
      haoxueduo: {},
      multipleSelection: [],
      desc: "",
      ids: "",
      statusAudio: "",
      checked: true,
      customColor: [
        { color: "#5cb87a", percentage: 15 },
        { color: "#e6a23c", percentage: 60 },
        { color: "#f56c6c", percentage: 80 },
      ],
      totalFileSize: 0,
      totalFileSizeLimit: 0,
    };
  },
  filters: {
    formatDate2(d) {
      return formatDate(d, "yyyy-MM-dd hh:mm:ss");
    },
  },
  computed: {
    percentage() {
      return Math.ceil((this.totalFileSize / this.totalFileSizeLimit) * 100);
    },
  },
  methods: {
    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    formatProgress() {
      return this.getSizeStr(this.totalFileSize) + "/" + this.getSizeStr(this.totalFileSizeLimit);
    },
    getSizeStr(bytes) {
      let size = ['bytes','Kb','Mb','Gb','Tb','Pb','Eb','Bb'];
      let i = 0;
      while(1023 < bytes){
        bytes /= 1024;
        ++i;
      }
      return bytes.toFixed(2) + ' ' + size[i];
    },
    onSubmit() {
      this.queryParams.page = 1;
      this.fetchQueryData();
    },
    //   新增专辑
    addAlbum() {
      this.desc = "addResource";
      this.dialogVisible = true;
      this.formFuzzy.name = "";
    },

    // 新建专辑下一步
    addResource() {
      if (this.checked == false) {
        alert("请同意并阅读《知识产权承诺》后进行下一步");
        return;
      }
      this.do = "add";
      this.albumFetch().then((res) => {
        this.$router.push({
          path: "/addAlbums",
          query: {
            id: res,
            doWhy: this.do,
            dbId: this.haoxueduo.id,
            totalFileSize: this.totalFileSize,
            totalFileSizeLimit: this.totalFileSizeLimit,
          },
        });
      });
    },
    // 查看知识产权
    lookKnowLedge() {
      this.cenceldialogVisible = true;
    },
    // 编辑专辑下一步
    editResource(row) {
      if (this.checked == false) {
        alert("请同意并阅读《知识产权承诺》后进行下一步");
        return;
      }
      this.do = "edit";
      this.albumFetch(row).then((res) => {
        this.$router.push({
          path: "/addAlbums",
          query: {
            id: row.id,
            doWhy: this.do,
            dbId: this.haoxueduo.id,
            totalFileSize: this.totalFileSize,
            totalFileSizeLimit: this.totalFileSizeLimit,
          },
        });
      });
    },
    // 建专辑
    albumFetch(row) {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          pid: 0,
          dbId: this.haoxueduo.id,
          status: 0,
        };
        if(row && row.layerType ==1 || this.do == "add"){
          params.type = 0
        }else{
          params.type = 2
        }
        if (row && row.id != "") {
          params.id = row.id;
        } else {
          params.id = 0;
        }
        if (this.statusAudio != "") {
          params.status = this.statusAudio;
        } else {
          params.status = 0;
        }
        if (this.formFuzzy.name != "") {
          params.name = this.formFuzzy.name.trim();
        } else {
          alert("资源名称不能为空");
          return;
        }
        this.$axios
          .post("/aries-api/album/save", params)
          .then((response) => {
            resolve(response.data.data.id);
            // this.fetchQueryData();
            console.log(
              response.data.data.id,
              "responseresponseresponseresponse-----------albumFetch"
            );
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(row) {
      this.desc = "editResource";
      this.dialogVisible = true;
      this.formFuzzy.name = row.name;
      this.ids = row;
      this.statusAudio = row.status;
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchQueryData();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchQueryData();
    },
    delResource() {
      if (this.multipleSelection.length == 0) {
        alert("请先勾选专辑");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除？",
        content: "<ul><li>请确认是否删除专辑</li></ul>",
        onOk: () => {
          let ids = [];
          for (let i = 0; i < this.multipleSelection.length; ++i) {
            let idDel = this.multipleSelection[i].id;
            ids.push(idDel);
          }
          let params = {
            appId: this.$API.APPID,
            ids: ids,
            is_delete_res: 1, //删除专辑下所有音频
          };
          this.$axios
            .post("/aries-api/album/delete", params)
            .then((response) => {
              console.log(response);
              let m = response.data;
              if (m.result == 0) {
                this.fetchQueryData();
                this.$Message.success("删除成功!");
              } else {
                ApiMessage(this, m.err, "error");
              }
            })
            .catch((error) => {
              ApiMessage(this, error.toString(), "error");
            });
        },
      });
    },
    // 查看自有图书下的内容提供商--- 好学多音频资源
    initCplists() {
      let params = {
        appId: this.$API.APPID,
        //otype: 2,
        dtype: 0,
        onlyAuthorised: 1,
        needAppName: 1,
      };
      this.$axios
        .post("/aries-api/resourceDb/list", params)
        .then((response) => {
          console.log(response, "response===");
          if (response.data.result == "0") {
            if (
              response.data.data.length != 0 &&
              response.data.data.own &&
              response.data.data.own.length != 0
            ) {
              this.ownCpList = JSON.parse(
                JSON.stringify(response.data.data.own)
              );
              this.haoxueduo = this.ownCpList.find((item) => {
                return item.name === "好学多音频资源";
              });
              console.log(this.haoxueduo, "this.haoxueduo-----好学多音频资源");
              // own dtype=0 有数据查不到自动创建
              if (
                this.haoxueduo == undefined ||
                Object.keys(this.haoxueduo).length == 0
              ) {
                this.AutoAddCP();
              }
              // own dtype=0 没有一条数据自动创建
            } else {
              this.AutoAddCP();
            }
          }
          this.fetchQueryData();
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    //自动创建好学多音频资源CP
    AutoAddCP() {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          dtype: 0, //选填，cp类型 0 音视频类| 1 书籍类
          name: "好学多音频资源", //必填
          logo: "", //选填
          is_open: 1, //必填
          otype: 2, //资源库类型，可选值 0系统库  1开发者库   2应用私有库， 选填
          id: 0,
          description: "自动创建-好学多音频资源",
        };
        this.$axios
          .post("/aries-api/resourceDb/save", params)
          .then((response) => {
            console.log(response);
            if (response.data.result == "0") {
              this.initCplists();
              resolve(response.data.data.id);
            } else {
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },

    upResource() {
      this.upDownResource(1);
    },
    downResource() {
      this.upDownResource(0);
    },
    // 上下架
    upDownResource(online) {
      if (this.multipleSelection.length == 0) {
        alert("请先勾选专辑");
        return;
      }
      let ids = [];
      for (let i = 0; i < this.multipleSelection.length; ++i) {
        let id = this.multipleSelection[i].id;
        ids.push(id);
      }
      let params = {
        appId: this.$API.APPID,
        ids: ids,
        status: online,
      };
      this.$axios
        .post("/aries-api/album/online", params)
        .then((response) => {
          console.log(response);
          if (response.data.result == "0") {
            this.fetchQueryData();
            this.$Message.success("操作成功!");
          } else {
            alert(response.data.err);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },

    // 删除音频--- 测试专用！！！
    // deletesss() {
    //   for (var oid = 1311; oid < 1312; oid++) {
    //     console.log(oid);
    //     let params = {
    //       id: oid,
    //       appId: this.$API.APPID,
    //     };
    //     this.$axios
    //       .post("/aries-api/resourceDb/delete", params)
    //       .then((response) => {
    //         console.log(response);
    //         let m = response.data;
    //         if (m.result == 0) {
    //           this.$Message.success("删除成功!");
    //         } else {
    //           ApiMessage(this, m.msg, "error");
    //         }
    //       })
    //       .catch((error) => {
    //         ApiMessage(this, error.toString(), "error");
    //       });
    //   }
    // },

    // 获取专辑列表-搜索
    fetchQueryData() {
      this.loading = true;
      let cpid = [];
      cpid.push(this.haoxueduo.id);
      let params = {
        appId: this.$API.APPID,
        dbId: cpid,
        needFileSizeLimit: 1,
        pid:0,//只显示一级
        needLayerType:1,
      };
      if (this.formResource.name != "") {
        params.name = this.formResource.name;
      }
      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      this.$axios
        .post("/aries-api/album/list", params)
        .then((response) => {
          if (response.data.result == 0) {
            console.log(response.data);
            this.queryData = response.data.data.list;
            this.pageTotal = response.data.data.pager.total;
            this.totalFileSize = response.data.data.totalFileSize;
            this.totalFileSizeLimit = response.data.data.totalFileSizeLimit;
            this.loading = false;
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
  },
};
</script>

<style lang="less" >
@import "../fyd-style";
@import "../commonEdu";
.class_progerss {
  width: 400px;
  height: 10px;
  margin-left: 25px;
  .el-progress-bar__outer {
    height: 10px !important;
  }
  .el-progress-bar {
    width: 75%;
  }
}
</style>



// WEBPACK FOOTER //
// audioResources.vue?366eab12